<p-toast></p-toast>

<!-- Add / edit customer. Chrome comes from styles/components/_dialogs.scss; closable stays on so Escape closes it. -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-lg premium-dialog"
  [showHeader]="false"
  (onHide)="onDialogHide()"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">{{ dialogHeader }}</h3>
      <p class="premium-subtitle">Mobile number is required; everything else is optional</p>
    </div>
    <button
      type="button"
      class="premium-close-btn"
      (click)="onDialogHide()"
      aria-label="Close"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
    <div class="premium-body">
      <!-- Company Information Section -->
      <div class="form-section">
        <h3 class="section-title">Company Information</h3>

        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="customer_name">Customer Name</label>
              <input
                #customerNameInput
                id="customer_name"
                type="text"
                pInputText
                formControlName="customer_name"
                placeholder="Walk in Customer"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('customer_name')?.hasError('pattern') &&
                  customerForm.get('customer_name')?.touched
                "
              >
                Special characters are not allowed
              </small>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="mobile_no"
                >Mobile No <span class="required">*</span></label
              >
              <input
                id="mobile_no"
                type="text"
                pInputText
                formControlName="mobile_no"
                placeholder="Enter 10-digit Mobile No"
                maxlength="10"
                (keypress)="allowOnlyNumbers($event)"
                (input)="sanitizeMobileNumber($event)"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('mobile_no')?.invalid &&
                  customerForm.get('mobile_no')?.touched
                "
              >
                Valid 10-digit mobile number is required
              </small>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="address">Address</label>
              <input
                id="address"
                type="text"
                pInputText
                formControlName="address"
                placeholder="Enter House No"
              />
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="address2">Address 2</label>
              <input
                id="address2"
                type="text"
                pInputText
                formControlName="address2"
                placeholder="Enter Street Name"
              />
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="address3">Address 3</label>
              <input
                id="address3"
                type="text"
                pInputText
                formControlName="address3"
                placeholder="Enter Area Name"
              />
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="zip_code">Zip Code</label>
              <input
                id="zip_code"
                type="text"
                pInputText
                formControlName="zip_code"
                placeholder="Enter Zip Code"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('zip_code')?.hasError('pattern') &&
                  customerForm.get('zip_code')?.touched
                "
              >
                Only alphanumeric characters and hyphens are allowed
              </small>
            </div>
          </div>
          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="country_id">Country</label>
              <p-dropdown
                id="country_id"
                formControlName="country_id"
                [options]="countries"
                optionLabel="name"
                optionValue="id"
                placeholder="Select Country"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                emptyFilterMessage="No match found"
                emptyMessage="No countries available"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="state_id">State</label>
              <p-dropdown
                id="state_id"
                formControlName="state_id"
                [options]="states"
                optionLabel="name"
                optionValue="id"
                placeholder="Select State"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                [disabled]="!customerForm.get('country_id')?.value"
                emptyFilterMessage="No match found"
                emptyMessage="Please select a country first"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="city_id">City</label>
              <p-dropdown
                id="city_id"
                formControlName="city_id"
                [options]="cities"
                optionLabel="name"
                optionValue="id"
                placeholder="Select City"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                [disabled]="!customerForm.get('state_id')?.value"
                emptyFilterMessage="No match found"
                emptyMessage="Please select a state first"
              >
              </p-dropdown>
            </div>
          </div>
          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="gst_no">GSTIN No</label>
              <input
                id="gst_no"
                type="text"
                pInputText
                formControlName="gst_no"
                placeholder="e.g. 22AAAAA0000A1Z5"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('gst_no')?.hasError('pattern') &&
                  customerForm.get('gst_no')?.touched
                "
              >
                Only alphanumeric characters are allowed
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Information Section -->
      <div class="form-section" *ngIf="isContactEnabled">
        <h3 class="section-title">Contact Information</h3>

        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="contact_person">Contact Person</label>
              <input
                id="contact_person"
                type="text"
                pInputText
                formControlName="contact_person"
                placeholder="Enter Contact Person"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('contact_person')?.hasError('pattern') &&
                  customerForm.get('contact_person')?.touched
                "
              >
                Special characters are not allowed
              </small>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="email">Email ID</label>
              <input
                id="email"
                type="email"
                pInputText
                formControlName="email"
                placeholder="Enter Email ID"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('email')?.invalid &&
                  customerForm.get('email')?.touched
                "
              >
                Valid email is required
              </small>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="sellingpricegroup_id">Selling Price Group</label>
              <p-dropdown
                id="sellingpricegroup_id"
                formControlName="sellingpricegroup_id"
                [options]="pricingGroups"
                optionLabel="name"
                optionValue="id"
                placeholder="Select Selling Price Group"
                [showClear]="true"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="pan_no">PAN No</label>
              <input
                id="pan_no"
                type="text"
                pInputText
                formControlName="pan_no"
                placeholder="e.g. ABCDE1234F"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('pan_no')?.hasError('pattern') &&
                  customerForm.get('pan_no')?.touched
                "
              >
                Only alphanumeric characters are allowed
              </small>
            </div>
          </div>

          <div class="p-col-12 p-md-6">
            <div class="p-field">
              <label for="fax_no">Fax No</label>
              <input
                id="fax_no"
                type="text"
                pInputText
                formControlName="fax_no"
                placeholder="Fax Number"
              />
              <small
                class="p-error"
                *ngIf="
                  customerForm.get('fax_no')?.hasError('pattern') &&
                  customerForm.get('fax_no')?.touched
                "
              >
                Invalid characters in fax number
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="premium-footer">
      <button
        type="button"
        class="premium-btn premium-btn-secondary"
        (click)="onDialogHide()"
        [disabled]="isSubmitting"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="premium-btn premium-btn-primary"
        [disabled]="isSubmitting"
      >
        <i *ngIf="isSubmitting" class="pi pi-spin pi-spinner"></i>
        Save
      </button>
    </div>
  </form>
</p-dialog>
